import { render, staticRenderFns } from "./import-export.vue?vue&type=template&id=6f31e828&scoped=true&"
import script from "./import-export.vue?vue&type=script&lang=js&"
export * from "./import-export.vue?vue&type=script&lang=js&"
import style0 from "./import-export.vue?vue&type=style&index=0&id=6f31e828&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f31e828",
  null
  
)

export default component.exports